import { computed, ref } from 'vue'

const viewportWidth = ref(window.innerWidth)
const viewportHeight = ref(window.innerHeight)

const update = () => {
  viewportWidth.value = window.innerWidth
  viewportHeight.value = window.innerHeight
}

window.addEventListener('resize', update)

const isMobile = computed(() => viewportWidth.value < 768)
const isTabletVertical = computed(
  () => viewportWidth.value >= 768 && viewportWidth.value < 1024
)
const isTabletHorizontal = computed(
  () => viewportWidth.value >= 1024 && viewportWidth.value < 1200
)
const isDesktop = computed(() => viewportWidth.value >= 1200)
const isDesktopLayout = computed(() => viewportWidth.value >= 1024)

const isMac =
  navigator.userAgent.toLowerCase().includes('mac') && !navigator.maxTouchPoints
const isWindows = navigator.userAgent.toLowerCase().includes('windows')
const isiOS =
  ['iphone', 'ipad'].includes(navigator.userAgent.toLowerCase()) ||
  (navigator.userAgent.toLowerCase().includes('mac') &&
    navigator.maxTouchPoints > 2)
const isAndroid = navigator.userAgent.toLowerCase().includes('android')
const isNative = computed(() => isiOS || isAndroid)

export function useDevice() {
  return {
    viewportWidth,
    viewportHeight,
    isMobile,
    isTabletVertical,
    isTabletHorizontal,
    isDesktop,
    isDesktopLayout,
    isNative,
    isMac,
    isWindows,
    isiOS,
    isAndroid,
  }
}
